import { pbUsers } from './adapters/pb-users'
import { notifyAdapter } from '@/features/messages/adapters/notify-adapter'
import { makeSyncedUsers } from './adapters/synced-users'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { UserPort } from './domain/user'

const users: UserPort = pbUsers
const notify: NotifyPort = notifyAdapter

// Synced observable - auto-fetches on first access
const settingsUsers$ = makeSyncedUsers(pbUsers, notifyAdapter)

export { users, notify, settingsUsers$ }
